import { render, staticRenderFns } from "./VEditor.vue?vue&type=template&id=18fd0cde&scoped=true&"
import script from "./VEditor.vue?vue&type=script&lang=js&"
export * from "./VEditor.vue?vue&type=script&lang=js&"
import style0 from "./VEditor.vue?vue&type=style&index=0&id=18fd0cde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd0cde",
  null
  
)

export default component.exports